import { BadgeVariants } from '@carboledger/ui';
import { ORDER_DISPLAY_STATUS } from './statuses';

// One Badge variant map per backend enum; separate from statuses.js, which mappers import.

export const CONTRACT_STATUS_TONE = Object.freeze({
  ACTIVE: BadgeVariants.success,
  CLOSED: BadgeVariants.default,
});

// FORWARD is an inbound_type, not a progress state — its own colour, not TO_RECEIVED's.
export const SHIPMENT_STATUS_TONE = Object.freeze({
  TO_RECEIVED: BadgeVariants.default,
  PARTIALLY_RECEIVED: BadgeVariants.warning,
  RECEIVED: BadgeVariants.success,
  FORWARD: BadgeVariants.info,
});

export const DECLARATION_STATUS_TONE = Object.freeze({
  // Figma 766:39719 — Draft blue, Processing orange, Pending red; Consumed is the grey one.
  DRAFT: BadgeVariants.primary,
  PROCESSING: BadgeVariants.warning,
  COMPLETED: BadgeVariants.success,
  PENDING: BadgeVariants.error,
  CONSUMED: BadgeVariants.default,
  REVOKED: BadgeVariants.error,
  REJECTED: BadgeVariants.error,
});

export const CUSTOMER_SITE_CERT_STATUS_TONE = Object.freeze({
  VERIFIED: BadgeVariants.success,
  REJECTED: BadgeVariants.error,
  NA: BadgeVariants.default,
});

export const VERIFICATION_STATUS_TONE = Object.freeze({
  VERIFIED: BadgeVariants.success,
  MANUALLY_VERIFIED: BadgeVariants.success,
  PENDING: BadgeVariants.warning,
  REJECTED: BadgeVariants.error,
  NA: BadgeVariants.default,
});

export const OUTGOING_SHIPMENT_STATUS_TONE = Object.freeze({
  PENDING: BadgeVariants.warning,
  PARTIALLY_ALLOCATED: BadgeVariants.info,
  ALLOCATED: BadgeVariants.success,
  CANCELLED: BadgeVariants.default,
});

export const ALLOCATION_STATUS_TONE = Object.freeze({
  'Pending declaration': BadgeVariants.default,
  'Pending shipment': BadgeVariants.warning,
  'Declaration generated': BadgeVariants.success,
  'Declaration updated': BadgeVariants.info,
  'Declaration rejected': BadgeVariants.error,
  'Credits retired': BadgeVariants.info,
  Revoked: BadgeVariants.error,
});

// Keyed by the text computePendingOrderDisplayStatus returns, like ALLOCATION_STATUS_TONE above.
export const ORDER_DISPLAY_STATUS_TONE = Object.freeze({
  [ORDER_DISPLAY_STATUS.active]: BadgeVariants.success,
  [ORDER_DISPLAY_STATUS.closed]: BadgeVariants.default,
  [ORDER_DISPLAY_STATUS.cancelled]: BadgeVariants.error,
});

// Keyed by the raw `transaction_status` code, not by ALLOCATION_STATUS_TONE's English text.
export const TRANSACTION_STATUS_TONE = Object.freeze({
  PENDING_DECLARATION: BadgeVariants.default,
  PENDING_SHIPMENT: BadgeVariants.warning,
  AWAITING_APPROVAL: BadgeVariants.warning,
  REJECTED: BadgeVariants.error,
  TRANSFERRED: BadgeVariants.info,
  DECLARATION_GENERATED: BadgeVariants.success,
  DECLARATION_UPDATED: BadgeVariants.info,
  CREDITS_RETIRED: BadgeVariants.info,
  DISPATCHED: BadgeVariants.success,
  REVOKED: BadgeVariants.error,
});

export const MATERIAL_DECLARATION_SETTINGS_TONE = Object.freeze({
  AVAILABLE: BadgeVariants.success,
  NOT_AVAILABLE: BadgeVariants.default,
});

export const CERTIFICATE_TYPE_TONE = Object.freeze({
  ISCC_EU: BadgeVariants.primary,
  ISCC_PLUS: BadgeVariants.warning,
  ISCC_CORSIA: BadgeVariants.info,
});

export const MB_PERIOD_STATUS_TONE = Object.freeze({
  SCHEDULED: BadgeVariants.success,
  OPEN: BadgeVariants.warning,
  CLOSED: BadgeVariants.default,
});

// TODO: the design also badges a "Transferred" type, which TransactionLedgerType has no member for.
export const TRANSACTION_LEDGER_TYPE_TONE = Object.freeze({
  INCOMING_DECLARATION: BadgeVariants.success,
  SURPLUS: BadgeVariants.success,
  WRITE_OFF: BadgeVariants.warning,
  OUTGOING_DECLARATION: BadgeVariants.error,
  REVERTED: BadgeVariants.default,
});

export const RECONCILIATION_STATUS_TONE = Object.freeze({
  Gain: BadgeVariants.success,
  Loss: BadgeVariants.error,
  Reconciled: BadgeVariants.info,
});

// Figma 4196:133489 — Allocated is the red one; Declaration generated is green.
export const MOVEMENT_STATUS_TONE = Object.freeze({
  TO_RECEIVE: BadgeVariants.warning,
  RECEIVED: BadgeVariants.success,
  SURPLUS: BadgeVariants.success,
  WRITE_OFF: BadgeVariants.error,
  DISPATCHED: BadgeVariants.warning,
  ALLOCATED: BadgeVariants.error,
  DECLARATION_GENERATED: BadgeVariants.success,
  FORWARD_INBOUND: BadgeVariants.info,
  FORWARD_OUTBOUND: BadgeVariants.info,
});
